export const platformList =  [
    {
      name: "海马运动",
      value: 1,
    },
    {
      name: "教练局",
      value: 2,
    }
  ]


  export const entryList =  [
    {
      name: "教练咨询",
      value: 'coach',
    },
    {
      name: "需求接单",
      value: 'need',
    },
    {
      name: "转人工",
      value: 'comm',
    },
  ]